

import banner from './banner';//banner
import news from "./news"; //资讯
import activity from "./activity"; //资讯
import dataCensus from "./dataCensus";//数据统计
import document from "./document";//文档中心
import documentPDF from "./documentPDF";//PDF文档中心
import recommend from "./recommend";//推荐文档
import notice from "./notice";//推荐文档
import member from "./member"
import recommendApp from "./recommendApp"
import activityEnroll from "./activityEnroll"
import importTask from "./importTask"

export default [
	...banner,
	...news,
  	...activity,
	...dataCensus,
	...document,
  	...documentPDF,
	...recommend,
	...notice,
	...member,
	...recommendApp,
	...activityEnroll,
	...importTask,
]
